var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDimProgress(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "556px",
    height: "22px",
    viewBox: "0 0 556 22",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 24") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Desktop",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Home-Light-",
    transform: "translate(-527.000000, -1830.000000)",
    fill: "#3CD672"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-25",
    transform: "translate(202.000000, 1672.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-24",
    transform: "translate(325.000000, 158.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-69",
    x: 552,
    y: 0,
    width: 4,
    height: 22,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-68",
    x: 544,
    y: 0,
    width: 4,
    height: 22,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-67",
    x: 536,
    y: 0,
    width: 4,
    height: 22,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-66",
    x: 528,
    y: 0,
    width: 4,
    height: 22,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-65",
    x: 520,
    y: 0,
    width: 4,
    height: 22,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-64",
    x: 512,
    y: 0,
    width: 4,
    height: 22,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-63",
    x: 504,
    y: 0,
    width: 4,
    height: 22,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-62",
    x: 496,
    y: 0,
    width: 4,
    height: 22,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-61",
    x: 488,
    y: 0,
    width: 4,
    height: 22,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-60",
    x: 480,
    y: 0,
    width: 4,
    height: 22,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-59",
    x: 472,
    y: 0,
    width: 4,
    height: 22,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-58",
    x: 464,
    y: 0,
    width: 4,
    height: 22,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-57",
    x: 456,
    y: 0,
    width: 4,
    height: 22,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-56",
    x: 448,
    y: 0,
    width: 4,
    height: 22,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-55",
    x: 440,
    y: 0,
    width: 4,
    height: 22,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-54",
    x: 432,
    y: 0,
    width: 4,
    height: 22,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-53",
    x: 424,
    y: 0,
    width: 4,
    height: 22,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-52",
    x: 416,
    y: 0,
    width: 4,
    height: 22,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-51",
    x: 408,
    y: 0,
    width: 4,
    height: 22,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-50",
    x: 400,
    y: 0,
    width: 4,
    height: 22,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-49",
    x: 392,
    y: 0,
    width: 4,
    height: 22,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-48",
    x: 384,
    y: 0,
    width: 4,
    height: 22,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-47",
    x: 376,
    y: 0,
    width: 4,
    height: 22,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-46",
    x: 368,
    y: 0,
    width: 4,
    height: 22,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-45",
    x: 360,
    y: 0,
    width: 4,
    height: 22,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-44",
    x: 352,
    y: 0,
    width: 4,
    height: 22,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-43",
    x: 344,
    y: 0,
    width: 4,
    height: 22,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-42",
    x: 336,
    y: 0,
    width: 4,
    height: 22,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-41",
    x: 328,
    y: 0,
    width: 4,
    height: 22,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-40",
    x: 320,
    y: 0,
    width: 4,
    height: 22,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-39",
    x: 312,
    y: 0,
    width: 4,
    height: 22,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-38",
    x: 304,
    y: 0,
    width: 4,
    height: 22,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-37",
    x: 296,
    y: 0,
    width: 4,
    height: 22,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-36",
    x: 288,
    y: 0,
    width: 4,
    height: 22,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-35",
    x: 280,
    y: 0,
    width: 4,
    height: 22,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-34",
    x: 272,
    y: 0,
    width: 4,
    height: 22,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-33",
    x: 264,
    y: 0,
    width: 4,
    height: 22,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-32",
    x: 256,
    y: 0,
    width: 4,
    height: 22,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-31",
    x: 248,
    y: 0,
    width: 4,
    height: 22,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-30",
    x: 240,
    y: 0,
    width: 4,
    height: 22,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-29",
    x: 232,
    y: 0,
    width: 4,
    height: 22,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-28",
    x: 224,
    y: 0,
    width: 4,
    height: 22,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-27",
    x: 216,
    y: 0,
    width: 4,
    height: 22,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-26",
    x: 208,
    y: 0,
    width: 4,
    height: 22,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-25",
    x: 200,
    y: 0,
    width: 4,
    height: 22,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-24",
    x: 192,
    y: 0,
    width: 4,
    height: 22,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-23",
    x: 184,
    y: 0,
    width: 4,
    height: 22,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-22",
    x: 176,
    y: 0,
    width: 4,
    height: 22,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-21",
    x: 168,
    y: 0,
    width: 4,
    height: 22,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-20",
    x: 160,
    y: 0,
    width: 4,
    height: 22,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-19",
    x: 152,
    y: 0,
    width: 4,
    height: 22,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-18",
    x: 144,
    y: 0,
    width: 4,
    height: 22,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-17",
    x: 136,
    y: 0,
    width: 4,
    height: 22,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-16",
    x: 128,
    y: 0,
    width: 4,
    height: 22,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-15",
    x: 120,
    y: 0,
    width: 4,
    height: 22,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-14",
    x: 112,
    y: 0,
    width: 4,
    height: 22,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-13",
    x: 104,
    y: 0,
    width: 4,
    height: 22,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-12",
    x: 96,
    y: 0,
    width: 4,
    height: 22,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-11",
    x: 88,
    y: 0,
    width: 4,
    height: 22,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-10",
    x: 80,
    y: 0,
    width: 4,
    height: 22,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-9",
    x: 72,
    y: 0,
    width: 4,
    height: 22,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-8",
    x: 64,
    y: 0,
    width: 4,
    height: 22,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-7",
    opacity: 0.383051554,
    x: 56,
    y: 0,
    width: 4,
    height: 22,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-6",
    x: 48,
    y: 0,
    width: 4,
    height: 22,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-5",
    x: 40,
    y: 0,
    width: 4,
    height: 22,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-4",
    x: 32,
    y: 0,
    width: 4,
    height: 22,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-3",
    x: 24,
    y: 0,
    width: 4,
    height: 22,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-2",
    x: 16,
    y: 0,
    width: 4,
    height: 22,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy",
    x: 8,
    y: 0,
    width: 4,
    height: 22,
    rx: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 4,
    height: 22,
    rx: 2
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDimProgress);
export default __webpack_public_path__ + "static/media/dimProgress.6b2617be27f41ff7b335ca6c57af1c8b.svg";
export { ForwardRef as ReactComponent };